<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'onCallShift_selectMonthTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="row">
            <div class="col-6">
                <div class="form-field required">
                    <label class="form-label">{{'onCallShift_lblYear' | translate}}</label>
                    <app-select [(ngModel)]="year"
                                [options]="years"
                                [required]="true"
                                (selectionChange)="onYearChange()"
                                name="year">
                    </app-select>
                </div>
            </div>

            <div class="col-6">
                <div class="form-field required">
                    <label class="form-label">{{'onCallShift_lblMonth' | translate}}</label>
                    <app-select [(ngModel)]="month"
                                [options]="months"
                                [displayProperty]="'name'"
                                [required]="true"
                                name="month">
                    </app-select>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{'dialog_cancel' | translate}}</button>
    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!form.valid">{{'dialog_ok' | translate}}</button>
</div>
